export default function checkCountryModal(modalSelector, validCountry) {
    let $modal = $(modalSelector);
    let modalNativeSelector = document.querySelector( `${modalSelector} .wpcf7 form` );
    let $modalSent =  $(`${modalSelector}Sent`);
    let $modalCheckButton = $modal.find('#checkCountry');

    let $firstStep = $modal.find('.first-step');
    let $secondStep = $modal.find('.second-step');

    let $firstStepTitle = $modal.find('.first-step-title');
    let $secondStepTitle = $modal.find('.second-step-title');

    $secondStep.hide();
    $secondStepTitle.hide();

    $modal.on('shown.bs.modal', function () {
        $secondStep.hide();
        $secondStepTitle.hide();
        $modalSent.find('.icon').removeClass('fail-country');
    });

    $modal.on('hide.bs.modal', function () {
        $firstStep.show();
        $firstStepTitle.show();

        $secondStep.hide();
        $secondStepTitle.hide();

        $modal.find('.form-field').removeClass('not-empty disabled');
        $modal.find('[readonly]').attr("readonly", false);
        modalNativeSelector.reset();
    });


    $modalCheckButton.on('click', function (){
        let responseModalIcon   = $modalSent.find('.icon');
        let responseModalDesc  = $modalSent.find('.message');
        let resonseFailMessage = $modal.data('fail-country-check');

        let currentCuntry = $modal.find('[name=country]').val();

        if(currentCuntry == validCountry){
            $firstStep.hide();
            $firstStepTitle.hide();

            $secondStep.show();
            $secondStepTitle.show();
        }else{
            $modal.modal('hide');
            responseModalIcon.addClass('fail-country');
            responseModalDesc.text(resonseFailMessage)
            $modalSent.modal('show');
        }
    })
}
